import React from 'react';
import PropTypes from 'prop-types';


const propTypes = {
  children: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const fragmentRenderer = {
  root: ({ children }) => <>{children}</>,
  paragraph: ({ children }) => <>{children}</>,
};

fragmentRenderer.root.propTypes = propTypes;
fragmentRenderer.paragraph.propTypes = propTypes;
export default fragmentRenderer;
